class r extends HTMLElement {
  /**
   * Creates an instance of Accordion.
   */
  constructor() {
    super(), this._autoClose = !1, this._observer = null, this._boundOnToggle = this._onToggle.bind(this);
  }
  /**
   * Observed attributes for the custom element.
   * @static
   * @returns {Array<string>} An array of observed attribute names.
   */
  static get observedAttributes() {
    return ["auto-close"];
  }
  /**
   * Gets the autoClose property.
   * @public
   * @returns {boolean} The current value of the autoClose property.
   */
  get autoClose() {
    return this._autoClose;
  }
  /**
   * Sets the autoClose attribute.
   * @public
   * @param {boolean|string} val - The value to set the autoClose attribute to.
   */
  set autoClose(e) {
    this.setAttribute("auto-close", String(e));
  }
  /**
   * Lifecycle callback that gets invoked when the element is appended to the DOM.
   * Sets up mutation observer for child 'details' elements.
   */
  connectedCallback() {
    this._observer = new MutationObserver((e) => {
      e.forEach((t) => {
        if (t.attributeName === "open" && t.target) {
          const o = t.target;
          this._autoClose && o.open && this.querySelectorAll("details").forEach((s) => {
            s !== o && (s.open = !1);
          });
        }
      });
    }), this.querySelectorAll("details").forEach((e) => {
      var t;
      (t = this._observer) == null || t.observe(e, { attributes: !0 }), e.addEventListener("toggle", this._boundOnToggle);
    });
  }
  /**
   * Lifecycle callback that gets invoked when the element is removed from the DOM.
   * Disconnects the mutation observer.
   */
  disconnectedCallback() {
    var e;
    (e = this._observer) == null || e.disconnect(), this.querySelectorAll("details").forEach((t) => {
      t.removeEventListener("toggle", this._boundOnToggle);
    });
  }
  /**
   * Handles the toggling of details elements.
   * @private
   * @param {Event} event - The event object.
   */
  _onToggle(e) {
    const t = e.target;
    this._autoClose && t.open && this.querySelectorAll("details").forEach((o) => {
      o !== t && (o.open = !1);
    });
  }
  /**
   * Lifecycle callback that gets invoked when the attribute of the element changes.
   * @param {string} name - Name of the attribute that changed.
   * @param {string|null} _ - Old value of the attribute.
   * @param {string|null} newValue - New value of the attribute.
   */
  attributeChangedCallback(e, t, o) {
    switch (e) {
      case "auto-close":
        this._autoClose = o !== null;
        break;
    }
  }
}
customElements.get("bdk-accordion") || customElements.define("bdk-accordion", r);
export {
  r as default
};
